import ReactOnRails from 'react-on-rails';

import FacilitatorAssessmentSessionsIndex from './FacilitatorAssessmentSessionsIndex';
import FacilitatorAssessmentSessionsNew from './FacilitatorAssessmentSessionsNew';
import FacilitatorAssessmentSessionShow from './FacilitatorAssessmentSessionShow';
import FacilitatorAssessmentReport from './FacilitatorAssessmentReport';
import ParticipantAssessmentWizard from './ParticipantAssessmentWizard';
import FacilitatorAssessmentSessionQRCode from './FacilitatorAssessmentSessionQRCode';
import FacilitatorAssessmentSessionsEdit from './FacilitatorAssessmentSessionsEdit';

ReactOnRails.register({
  FacilitatorAssessmentSessionsIndex,
  FacilitatorAssessmentSessionsNew,
  FacilitatorAssessmentSessionShow,
  FacilitatorAssessmentReport,
  ParticipantAssessmentWizard,
  FacilitatorAssessmentSessionQRCode,
  FacilitatorAssessmentSessionsEdit,
});

export { default as Home } from './Home'
export { default as Dashboard } from './Dashboard'